import { render, staticRenderFns } from "./LuExciseTaxRates.vue?vue&type=template&id=5b1a2db1&"
import script from "./LuExciseTaxRates.vue?vue&type=script&lang=js&"
export * from "./LuExciseTaxRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports